import { render, staticRenderFns } from "./OrderMenu.vue?vue&type=template&id=0c60c15f"
import script from "./OrderMenu.vue?vue&type=script&lang=js"
export * from "./OrderMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports